// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailG":"G_d2xDetailG__wOJ1I"};